import type { A2ATransfersTransactionKind } from '@dock/types-dock-partner';

import a2aDetailsLang from '../../../lang/a2aDetails';

export const a2aTransferTransactionKindMap: Record<A2ATransfersTransactionKind, string> = {
    Pull: a2aDetailsLang.TRANSFER_TRANSACTION_KIND.PULL,
    Push: a2aDetailsLang.TRANSFER_TRANSACTION_KIND.PUSH,
};
